import { apolloClient } from '@/services/apollo';
import { NewRegistrationSubscription } from '@/gql/members/ListRecentMembers.gql';

function init() {
  const now = new Date();
  if(Notification.permission === 'default'){
    Notification.requestPermission(console.log);
  }
  console.log(apolloClient);
  apolloClient.subscribe({
    query: NewRegistrationSubscription,
    variables: {
      since: new Date(now.getTime() - 1000 * 60 * 60),
    },
  }).subscribe({
    next(data) {
      const member = data.data.members[0];
      if(member){
        const title = 'C-Suite Community';
        let body = member.name;
        let icon = '';
        if(member.location){
          body += ` registered from ${member.location.city}, ${member.location.country_name}`;
          icon = `https://www.countryflags.io/${member.location.country}/flat/64.png`;
        }
        const notification = new Notification(title, {
          icon: icon,
          body: body,
          timestamp: member.createdAt
        });
        const audio = new Audio('/notification.mp3');
        audio.play();
        notification.onclick = (e) => {
          notification.close();
          window.focus();
        }
      }
    },
    error(error){
      console.error(error);
    }
  })
}

export default {
  init,
}
